import { useCallback } from 'react';
import { useNavigate } from 'react-router';
import { useToastMessageState } from '../../../../components/ToastMessage/ToastMessageProvider';
import { ROUTES } from '../../../../constants/RouteNameMapping';
import {
  BulkUploadStatusEvent,
  IBulkUploadStatusMessageDataModel,
  UploadStatus,
} from '../../../../data-models/bulk-upload-status.data-model';
import { IGenericSocketUpdate } from '../../../../data-models/socket-base.data-model';
import { useSocketEventSubscription } from '../../../../services/hooks/useSocketEventSubscription';

export function useBulkUploadStatusSubscription() {
  const { pushStatusToast } = useToastMessageState();
  const navigate = useNavigate();

  const handleBulkUploadStatus = useCallback(
    (update: IGenericSocketUpdate<IBulkUploadStatusMessageDataModel>) => {
      const message = update.data;
      if (message) {
        pushStatusToast({
          message,
          onViewReport:
            message.status === UploadStatus.error && message.uploadId
              ? () => {
                  navigate(`/${ROUTES.BULK_UPLOAD_REPORT}/${message.uploadId}`);
                }
              : undefined,
        });
      }
    },
    [navigate, pushStatusToast]
  );

  useSocketEventSubscription(BulkUploadStatusEvent, handleBulkUploadStatus);
}
